/** * 模块名称: WillStaff.vue - 会参谋 * 模块说明: * 创建时间: 2022-02-15 11:36
* 模块负责人: lkc * 修改记录: */
<template>
  <div>
    <!-- 头部 -->
    <div class="headBanner">
      <div class="headClass">
        <div class="tit">
          <h1>小科智能会参谋</h1>
          <h2>智能会议 无线投屏 书写白板</h2>
          <h2>一站式解决方案</h2>
          <h2>艺术美学与科技感兼收并蓄</h2>
        </div>
        <!-- <img src="@/assets/yj_6.png" alt="" /> -->
        <div class="div"></div>
      </div>
    </div>
    <div class="contBox">
      <h1>产品亮点</h1>
      <h3 class="productH3">智能书写 流畅批注</h3>
      <ul class="productCar">
        <li>
          <img src="@/assets/yc3.png" alt="" />
          <div class="titCont">
            <span>智能书写</span>
            <span
              >多人书写、双色书写、自动识别图形、智表格，随意缩放及移动笔记</span
            >
          </div>
        </li>
        <li>
          <img src="@/assets/yc3.png" alt="" />
          <div class="titCont">
            <span>快捷擦除</span>
            <span>支持物理板擦、手背擦除，便捷手势操作，轻松随心</span>
          </div>
        </li>
        <li>
          <img src="@/assets/yc3.png" alt="" />
          <div class="titCont">
            <span>畅快书写</span>
            <span>书写精度1mm，灵敏感应，4K超高清显示，书写无锯齿</span>
          </div>
        </li>
        <li>
          <img src="@/assets/yc3.png" alt="" />
          <div class="titCont">
            <span>保存途径多样</span>
            <span>扫码保存，邮件本地保存，即享即用</span>
          </div>
        </li>
      </ul>
      <h3 class="productH3">无线投屏 多屏互动</h3>
      <ul class="productCar">
        <li>
          <img src="@/assets/yc3.png" alt="" />
          <div class="titCont">
            <span>投屏方式多样</span>
            <span>智慧传屏器、APP、有线DLNA投屏</span>
          </div>
        </li>
        <li>
          <img src="@/assets/yc3.png" alt="" />
          <div class="titCont">
            <span>无线投屏效果</span>
            <span>1s极速投屏、反向操控、智能9分屏、多屏互动</span>
          </div>
        </li>
        <li>
          <img src="@/assets/yc3.png" alt="" />
          <div class="titCont">
            <span>匠心工艺</span>
            <span>0贴合工艺、原装进口LG屏、AG防眩光</span>
          </div>
        </li>
      </ul>
      <h3 class="productH3">智能视频会议</h3>
      <ul class="productCar">
        <li>
          <img src="@/assets/yc3.png" alt="" />
          <div class="titCont">
            <span>会议类型丰富</span>
            <span
              >全新会议系统支持本地会议、一键发起云会议、第三方视频会议软件</span
            >
          </div>
        </li>
        <li>
          <img src="@/assets/yc3.png" alt="" />
          <div class="titCont">
            <span>视频效果一流</span>
            <span>自有4K显示、高品质扬声器及麦克风，支持外接设备</span>
          </div>
        </li>
        <li>
          <img src="@/assets/yc3.png" alt="" />
          <div class="titCont">
            <span>抗扰能力强</span>
            <span>回声消除、噪音抑制、自动增益控制</span>
          </div>
        </li>
      </ul>
      <!-- 使用场景 -->
      <h1>使用场景</h1>
      <ul class="gpyScenario">
        <li>
          <img src="@/assets/bg.png" alt="" />
          <h2>办公领域</h2>
          <span>商务培训、部门会议、企业培训</span>
        </li>
        <li>
          <img src="@/assets/jy.png" alt="" />
          <h2>教育培训领域</h2>
          <span>幼儿教育、中小学教学、大学教学、职业教育</span>
        </li>
        <li>
          <img src="@/assets/cjyl.png" alt="" />
          <h2>医疗领域</h2>
          <span>手术室、远程会诊</span>
        </li>
        <li>
          <img src="@/assets/cjqt.png" alt="" />
          <h2>其他领域</h2>
          <span>设计公司、共享办公、多功能报告厅</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.headBanner {
  background: url('../../assets/hcmBanner.png');
  background-size: 100% 100%;
  .headClass {
    width: 1200px;
    height: 360px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .tit {
      width: 60%;
      color: #fff;
      // color: #000;
      text-align: left;
      h2 {
        margin: 10px 0;
      }
    }
    .div {
      width: 35%;
      // height: 300px;
    }
  }
}
.contBox {
  padding: 30px 40px;
  background: #f2f2f2;
  width: 1200px;
  box-sizing: border-box;
  margin: 0 auto;
  .productH3 {
    // text-align: left;
    margin-left: 8px;
    color: #fff;
    background-color: #297ae3;
    display: inline-block;
    display: flex;
    width: 160px;
    height: 30px;
    line-height: 30px;
    // text-align: center;
    border-radius: 5px;
    padding: 5px;
    // float: left;
  }
  .productCar {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 0;
    li {
      display: flex;
      align-items: flex-start;
      width: 40%;
      margin-bottom: 30px;
      text-align: left;
      img {
        margin-right: 5px;
      }
      .titCont {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        span:first-child {
          font-size: 20px;
          margin-bottom: 5px;
        }
        span:last-child {
          text-align: left;
        }
      }
    }
  }
  .gpyScenario {
    list-style: none;
    display: flex;
    justify-content: space-around;
    padding: 0;
    li {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 240px;
        height: 200px;
      }
      span {
        width: 240px;
        text-align: left;
      }
      h2 {
        width: 240px;
        text-align: left;
        margin: 10px 0;
        color: #297ae3;
      }
    }
  }
}
</style>
